
import isMobile from '../helpers/isMobile';

// -----------Share on Fb Messenger
const shareFbMessenger = () => {

    const fbMessenger = document.querySelectorAll('.social-share .fb-messenger-share');
    if (fbMessenger) {
        // init Fb
        window.fbAsyncInit = function () {
            FB.init({
                appId: '1214625195940877',
                xfbml: true,
                version: 'v2.9'
            });
            FB.AppEvents.logPageView();
        };


        fbMessenger.forEach((buttonFB) => {

            buttonFB.addEventListener('click', (event) => {
                event.preventDefault();

                var url = buttonFB.getAttribute('data-url');
                if (isMobile()) {
                    window.location.href = "fb-messenger://share/?link=" + url;
                } else {
                    FB.ui({
                        method: 'send',
                        link: url,
                        redirect_uri: url
                    });
                }
            });
        })
    }
}
export default shareFbMessenger;